module.exports = __webpack_public_path__ + "img/2.fff0f6ee.jpg";